import { TFunction } from 'i18next';

import router, { RouteItemType } from '~/core/router';
import PrivacyPolicyPage from '~/projects/polyllm-chat/components/LegalPage/components/PrivacyPolicyPage';
import SubscriptionTermsPage from '~/projects/polyllm-chat/components/LegalPage/components/SubscriptionTermsPage';
import TermsOfUsePage from '~/projects/polyllm-chat/components/LegalPage/components/TermsOfUsePage';
const PrivacyPolicyPath = '/legal/privacy-policy';
const SubscriptionTermsPath = '/legal/subscription-terms';
const TermsOfUsePath = '/legal/terms-of-use';
const getPrivacyTitle = (t: TFunction): string => t('general:privacy_policy');
const getSubscriptionTermsTitle = (t: TFunction): string =>
  t('general:subscription_terms');
const getTermsTitle = (t: TFunction): string => t('general:terms_of_use');
const LegalRoutes: RouteItemType[] = [
  {
    Component: PrivacyPolicyPage,
    path: PrivacyPolicyPath,
    getTitle: getPrivacyTitle,
  },
  {
    Component: SubscriptionTermsPage,
    path: SubscriptionTermsPath,
    getTitle: getSubscriptionTermsTitle,
  },
  {
    Component: TermsOfUsePage,
    path: TermsOfUsePath,
    getTitle: getTermsTitle,
  },
];
router.addUnAuthorizedRoutes(LegalRoutes);
